import { Link } from 'react-router-dom';
import { shopProducts } from '@/mocks/shop';

const featured = [
  shopProducts.find(p => p.id === '2')!,
  shopProducts.find(p => p.id === '3')!,
  shopProducts.find(p => p.id === '5')!,
  shopProducts.find(p => p.id === '1')!,
];

const highlights = [
  { icon: 'ri-pen-nib-line', label: '精品钢笔', color: 'bg-amber-50 text-amber-600', desc: '英雄/晨光品牌' },
  { icon: 'ri-book-open-line', label: '教辅书籍', color: 'bg-emerald-50 text-emerald-600', desc: '高考/考研专用' },
  { icon: 'ri-t-shirt-line', label: '学生服装', color: 'bg-rose-50 text-rose-600', desc: '校服/运动套装' },
  { icon: 'ri-store-2-line', label: '厂家直供', color: 'bg-orange-50 text-orange-600', desc: '品质保障低价' },
];

export default function ShopPreviewSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-red-500 text-xs font-semibold tracking-widest uppercase mb-1">学习用品一站购齐</p>
            <h2 className="text-3xl md:text-4xl font-black text-gray-900">
              精品书本 · 钢笔 · 学生服装
            </h2>
            <p className="text-gray-500 mt-2 text-sm">厂家直供，品质保障，支持微信/支付宝/信用卡支付</p>
          </div>
          <Link
            to="/shop"
            className="flex items-center gap-2 text-red-600 font-semibold text-sm hover:gap-3 transition-all cursor-pointer whitespace-nowrap"
          >
            进入商城 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Category Highlights */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
          {highlights.map(h => (
            <Link key={h.label} to="/shop" className="flex items-center gap-3 p-4 rounded-2xl border border-gray-100 hover:border-red-200 hover:scale-[1.02] transition-all cursor-pointer group">
              <div className={`w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0 ${h.color}`}>
                <i className={`${h.icon} text-xl`}></i>
              </div>
              <div>
                <p className="font-bold text-gray-900 text-sm">{h.label}</p>
                <p className="text-xs text-gray-400">{h.desc}</p>
              </div>
            </Link>
          ))}
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-8">
          {featured.map(product => (
            <Link
              key={product.id}
              to={`/shop/${product.id}`}
              className="bg-[#faf9f7] rounded-2xl overflow-hidden group cursor-pointer hover:scale-[1.02] transition-all block"
              data-product-shop
            >
              <div className="relative overflow-hidden h-52">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 bg-red-600 text-white text-xs px-2.5 py-1 rounded-full font-medium">
                  -{Math.round((1 - product.price / product.originalPrice) * 100)}%
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs text-gray-400 mb-1">{product.merchant}</p>
                <h3 className="font-bold text-gray-900 text-sm leading-snug mb-2 line-clamp-2">{product.name}</h3>
                <div className="flex items-center gap-1 mb-3">
                  <i className="ri-star-fill text-amber-400 text-xs"></i>
                  <span className="text-xs font-semibold text-gray-700">{product.rating}</span>
                  <span className="text-xs text-gray-400">({product.sales.toLocaleString()}件已售)</span>
                </div>
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-red-600 font-bold text-base">¥{product.price}</span>
                    <span className="text-gray-300 text-xs line-through ml-1">¥{product.originalPrice}</span>
                  </div>
                  <span className="px-3 py-1.5 rounded-full text-xs font-semibold bg-red-600 text-white whitespace-nowrap">
                    立即购买
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Seller CTA Banner */}
        <div className="bg-gradient-to-r from-orange-600 to-red-700 rounded-2xl px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl flex-shrink-0">
              <i className="ri-store-3-line text-white text-2xl"></i>
            </div>
            <div>
              <p className="text-white font-black text-base">工厂/商家入驻</p>
              <p className="text-white/70 text-xs mt-0.5">注册卖家账号，上传商品，直接触达全国学生家长</p>
            </div>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <Link
              to="/seller/dashboard"
              className="flex items-center gap-2 px-6 py-2.5 bg-white text-red-700 text-sm font-black rounded-full hover:bg-red-50 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-store-2-line"></i>立即入驻
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
